import { defineComponent as _defineComponent } from 'vue'
import { onBeforeMount, onMounted } from 'vue'
import { storeToRefs } from 'pinia'
import ProfileToolbar from '@/components/layout/ProfileToolbar.vue'
import type CustomWindow from '@/misc/custom-window'
import type User from '@/types/User'
import { useMainStore } from '@/stores/main-store'
import FluentMegaphoneLoud28Filled from '@/components/icons/FluentMegaphoneLoud28Filled.vue'
import { type RemovableRef, useStorage } from '@vueuse/core'
import LanguageType from '@/enums/LanguageType'

declare const window: CustomWindow


export default /*#__PURE__*/_defineComponent({
  __name: 'SidebarBottomNav',
  props: {
    tenantLanguages: null,
    propUser: null,
    defaultCompanyName: null
  },
  setup(__props: any) {

const props = __props as {
  tenantLanguages: { id: string, type: string }[];
  propUser?: User;
  defaultCompanyName: string;
};



const hasUnreadChangelogs = useStorage(`unread-changelogs-${window.user_id}`, false, sessionStorage) as RemovableRef<boolean>

const mainStore = useMainStore()

const {
  user,
  profilePicture,
  companyName,
  languages,
  primaryLanguage,
  selectedLanguage
} = storeToRefs(mainStore)

onBeforeMount(() => {
  user.value = props.propUser ?? window.user
  companyName.value = props.defaultCompanyName
  hasUnreadChangelogs.value = window.user_has_unread_changelogs

  if (user.value.profile_picture_big) {
    profilePicture.value = user.value.profile_picture_big
  }

  primaryLanguage.value = props.tenantLanguages.find(language => language.type === LanguageType.PRIMARY)?.id ?? null
  selectedLanguage.value = primaryLanguage.value
  languages.value = props.tenantLanguages
})

onMounted(() => {
  if (!window.Echo) return

  window.Echo.private(`App.Models.User.${window.user_id}`)
    .notification((notification: any) => {
      if (notification.type === 'App\\Notifications\\ChangelogPublished') hasUnreadChangelogs.value = true
    })
})

return { __sfc: true,props, hasUnreadChangelogs, mainStore, user, profilePicture, companyName, languages, primaryLanguage, selectedLanguage, ProfileToolbar, FluentMegaphoneLoud28Filled }
}

})